import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-004ad74c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图书", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "数据分析", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图书明细", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "分类", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图书分类管理", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图书馆", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图书馆信息", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Notebook = _resolveComponent("Notebook")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_List = _resolveComponent("List")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_Memo = _resolveComponent("Memo")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_Histogram = _resolveComponent("Histogram")!
  const _component_CircleCheck = _resolveComponent("CircleCheck")!
  const _component_School = _resolveComponent("School")!
  const _component_MessageBox = _resolveComponent("MessageBox")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_image, {
        style: {"width":"200px"},
        src: _ctx.banner12,
        fit: "scale-down"
      }, null, 8, ["src"])
    ], 512), [
      [_vShow, !_ctx.isShow]
    ]),
    _createVNode(_component_el_scrollbar, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu, {
          router: "",
          "unique-opened": "",
          collapse: _ctx.isShow,
          "default-active": _ctx.route.path
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/",
              class: "logo"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "1" }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Notebook)
                  ]),
                  _: 1
                }),
                _hoisted_3
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "/library/analysis" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_List)
                      ]),
                      _: 1
                    }),
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/library/book" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Memo)
                      ]),
                      _: 1
                    }),
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "2" }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Histogram)
                  ]),
                  _: 1
                }),
                _hoisted_6
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "/library/classify" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_CircleCheck)
                      ]),
                      _: 1
                    }),
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "3" }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_School)
                  ]),
                  _: 1
                }),
                _hoisted_8
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "/library/library" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_MessageBox)
                      ]),
                      _: 1
                    }),
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["collapse", "default-active"])
      ]),
      _: 1
    })
  ], 64))
}